import type { IValueLabel } from "./types"

export const accountStatuses: IValueLabel[] = [
  { value: "ACTIVE", label: "Active" },
  { value: "PROVIDER_ACCEPT", label: "Provider Accept" },
  { value: "CANCELLED", label: "Cancelled" },
  { value: "DUPLICATE", label: "Duplicate" },
  { value: "REJECT", label: "Reject" },
  { value: "INELIGIBLE", label: "Ineligible" },
  { value: "INACTIVE", label: "Inactive" },
]

export const accountStatusReasons: IValueLabel[] = [
  {
    value: "ACCOUNT_ALREADY_ACTIVE",
    label: "Account already active",
  },
  {
    value: "ACCOUNT_EXISTS_NOT_ACTIVE",
    label: "Account exists, but not active",
  },
  {
    value: "ACCOUNT_NUMBER_NOT_FOUND",
    label: "Account number not found/area not serviced",
  },
  { value: "CUSTOMER_REQUEST", label: "Customer request" },
  {
    value: "CUSTOMER_ON_ASSISTANCE",
    label: "Customer on assistance program",
  },
  { value: "SUBMIT_ISSUE", label: "Submit Issue" },
]

export const orderStatuses: IValueLabel[] = [
  { value: "CANCELLED", label: "Cancelled" },
]

export const orderStatusReasons: IValueLabel[] = [
  { value: "DUPLICATE", label: "Duplicate" },
  { value: "OUT_OF_MARKET", label: "Out of market" },
  { value: "WORKED", label: "Worked" },
]

export const revenueClasses: IValueLabel[] = [
  { value: "RESI", label: "RESI" },
  { value: "SMALL-COM", label: "SMALL-COM" },
]

export const states: IValueLabel[] = [
  { label: "Alabama", value: "AL" },
  { label: "Alaska", value: "AK" },
  { label: "Arizona", value: "AZ" },
  { label: "Arkansas", value: "AR" },
  { label: "California", value: "CA" },
  { label: "Colorado", value: "CO" },
  { label: "Connecticut", value: "CT" },
  { label: "Delaware", value: "DE" },
  { label: "District of Columbia", value: "DC" },
  { label: "Florida", value: "FL" },
  { label: "Georgia", value: "GA" },
  { label: "Hawaii", value: "HI" },
  { label: "Idaho", value: "ID" },
  { label: "Illinois", value: "IL" },
  { label: "Indiana", value: "IN" },
  { label: "Iowa", value: "IA" },
  { label: "Kansas", value: "KS" },
  { label: "Kentucky", value: "KY" },
  { label: "Louisiana", value: "LA" },
  { label: "Maine", value: "ME" },
  { label: "Maryland", value: "MD" },
  { label: "Massachusetts", value: "MA" },
  { label: "Michigan", value: "MI" },
  { label: "Minnesota", value: "MN" },
  { label: "Mississippi", value: "MS" },
  { label: "Missouri", value: "MO" },
  { label: "Montana", value: "MT" },
  { label: "Nebraska", value: "NE" },
  { label: "Nevada", value: "NV" },
  { label: "New Hampshire", value: "NH" },
  { label: "New Jersey", value: "NJ" },
  { label: "New Mexico", value: "NM" },
  { label: "New York", value: "NY" },
  { label: "North Carolina", value: "NC" },
  { label: "North Dakota", value: "ND" },
  { label: "Ohio", value: "OH" },
  { label: "Oklahoma", value: "OK" },
  { label: "Oregon", value: "OR" },
  { label: "Pennsylvania", value: "PA" },
  { label: "Puerto Rico", value: "PR" },
  { label: "Rhode Island", value: "RI" },
  { label: "South Carolina", value: "SC" },
  { label: "South Dakota", value: "SD" },
  { label: "Tennessee", value: "TN" },
  { label: "Texas", value: "TX" },
  { label: "Utah", value: "UT" },
  { label: "Vermont", value: "VT" },
  { label: "Virginia", value: "VA" },
  { label: "Washington", value: "WA" },
  { label: "West Virginia", value: "WV" },
  { label: "Wisconsin", value: "WI" },
  { label: "Wyoming", value: "WY" },
]

export const contactTypes: IValueLabel[] = [
  { value: "inbound - offline", label: "inbound - offline" },
  { value: "mail", label: "mail" },
  { value: "facebook", label: "facebook" },
  { value: "twitter", label: "twitter" },
  { value: "escalation callback", label: "escalation callback" },
]

export const phoneNumberTypes: IValueLabel[] = [
  { value: "mobile", label: "Mobile" },
  { value: "home", label: "Home" },
  { value: "work", label: "Work" },
]

export const contactLanguages: IValueLabel[] = [
  { value: "ENGLISH", label: "English" },
  { value: "SPANISH", label: "Spanish" },
]

export const defaultDispositions: IValueLabel[] = [
  { value: "Live Call", label: "Live Call" },
  { value: "Call Back", label: "Call Back" },
  { value: "Left Voicemail", label: "Left Voicemail" },
  { value: "Left Message", label: "Left Message" },
  { value: "No Answer", label: "No Answer" },
  { value: "Ops Work", label: "Ops Work" },
]

export const resubmitDispositions: IValueLabel[] = [
  { value: "ECL", label: "ECL" },
  { value: "Bill Image", label: "Bill Image" },
  { value: "Inbound Phone Call", label: "Inbound Phone Call" },
  { value: "Outbound Phone Call", label: "Outbound Phone Call" },
  { value: "Email", label: "Email" },
  { value: "Ops Work", label: "Ops Work" },
  { value: "Chat", label: "Chat" },
  { value: "Text Message", label: "Text Message" },
]

export const businessTitles: IValueLabel[] = [
  { value: "Landlord", label: "Landlord" },
  { value: "Business Owner", label: "Business Owner" },
  { value: "Business Partner", label: "Business Partner" },
  { value: "Manager", label: "Manager" },
]

export const accountHolderRelationship: IValueLabel[] = [
  { value: "Self", label: "Self" },
  { value: "Spouse/Domestic Partner", label: "Spouse/Domestic Partner" },
  { value: "Roommate", label: "Roommate" },
  { value: "Tenant", label: "Tenant" },
  { value: "Immediate Family", label: "Immediate Family" },
]

export const caseAssignmentGroups: IValueLabel[] = [
  { value: "all", label: "All" },
  { value: "roles", label: "My Team's Cases" },
  { value: "created", label: "Created by Me" },
  { value: "assigned", label: "Assigned to Me" },
]
